import * as React from 'react';
import {WrappedFieldProps} from 'redux-form';
import 'react-dates/initialize';
import {SingleDatePicker} from 'react-dates';
import 'react-dates/lib/css/_datepicker.css';
import moment from 'moment';

type Props = {
    label: string;
    type: string;
    max?: number;
    min?: number;
    disabled: boolean;
    startDateLabel: string;
    endDateLabel: string;
    wrapperClassName?: string;
    placeholder?: string;
    e2eId?: string;
    allowPastDates?: boolean;
};

type State = {
    focusedInput: any;
};

class DatePickerField extends React.PureComponent<WrappedFieldProps & Props, State> {
    constructor(props: WrappedFieldProps & Props) {
        super(props);
        this.state = {
            focusedInput: null
        };
        this.handleFocusChange = this.handleFocusChange.bind(this);
    }

    public handleFocusChange(focusedInput) {
        this.setState({focusedInput});
    }

    public render() {
        const {input, disabled, wrapperClassName, placeholder, allowPastDates} = this.props;
        const {
            meta,
            label
        } = this.props;

        const {focusedInput} = this.state;
        let value = (input && input.value) ? moment(input.value) : null;
        value = (value === null || !value.isValid()) ? null : value;

        return (
            <div className={`form-field ${wrapperClassName}`}>
                <label htmlFor={input.name} className="form-field__label"
                       date-e2eid={(this.props.e2eId) ? this.props.e2eId : null}>{label}</label>
                <div className="date-picker">
                    <SingleDatePicker
                        id={input.name}
                        focused={focusedInput}
                        onDateChange={date => {
                            const tempDate = date.clone();

                            if (value) {
                                tempDate.hour(value.get('hour'));
                                tempDate.minute(value.get('minute'));
                            }
                            input.onChange(tempDate)
                        }}
                        onFocusChange={(focusedObj) => {
                            this.handleFocusChange(focusedObj.focused)
                        }}
                        date={value}
                        readOnly={true}
                        noBorder={true}
                        block={false}
                        displayFormat="DD-MM-YYYY"
                        placeholder={placeholder}
                        isOutsideRange={day => allowPastDates ? false : moment().diff(day) > 0}
                        // isOutsideRange={() => !allowPastDates}
                    />
                    {(meta.touched &&
                        (meta.error && (
                            <div className="form-field__error"
                                 date-e2eid={(this.props.e2eId) ? this.props.e2eId + "_error" : null}>
                                {meta.error}
                            </div>
                        ))) ||
                    (meta.warning && <span>{meta.warning}</span>)}
                </div>
            </div>
        );
    }
}

export default DatePickerField;



// WEBPACK FOOTER //
// ./src/components/Layout/Form/Fields/DatePickerField.tsx